"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function MedalCheck16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16" }, props),
        react_1.default.createElement("path", { d: "m8 0 2.032 1.746h1.535V3L11 3.661l-1.638.146L8 2.637l-1.362 1.17-1.79-.146-.415 1.748-1.534.934L3.591 8 2.9 9.657l1.534.934.415 1.748 1.79-.146L8 13.363l1.362-1.17 1.79.146.415-1.748 1.534-.934L12.409 8h2.167l1.032 2.472-2.288 1.393-.618 2.607-2.67-.218L8 16l-2.032-1.746-2.67.218-.618-2.607-2.288-1.393L1.424 8 .392 5.528 2.68 4.135l.618-2.607 2.67.218L8 0Z" }),
        react_1.default.createElement("path", { d: "m5 8.047 1.362-1.464 1.751 1.629L12.5 4l1.362 1.464-5.749 5.48L5 8.046Z" }));
}
function MedalCheck16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(MedalCheck16Svg, Object.assign({}, svgProps)));
}
exports.default = MedalCheck16;
//# sourceMappingURL=MedalCheck16.js.map